import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import attachCredits from '../../api/credits/attach-credits';
import { getCart } from '../../reducers/cart';

const useAttachCredits = () => {
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: attachCredits,
        // TODO FE-249 Stage 2: swap for refetchCart(queryClient) once the cart moves to React Query
        onSuccess: () => new Promise<void>((resolve) => dispatch(getCart(resolve)))
    });
};

export default useAttachCredits;
